<template>
	<div class="chat-chat-order">
		<div class="chat-chat-order-title">
			<span class="chat-chat-ot-name"><span>{{chatUser.fans_wx_name}}</span>的订单信息</span>
			<span class="chat-chat-ot-close" @click="closeOrder">关闭</span>
		</div>
		<div class="chat-chat-order-search">
			<input type="datetime-local" v-model="requestParam.start_time">
			<input type="datetime-local" v-model="requestParam.end_time">
			<button type="button" @click="search">搜索</button>
			<button type="button" style="background-color: #2bad37;" @click="goOrder">下单</button>
			<button type="button" style="background-color: #ffaa00;" @click="changeOrder"><span v-if="requestParam.order_type === 1">第三方订单</span><span v-else>平台订单</span></button>
		</div>
		<div class="chat-chat-order-box">
			<div class="chat-chat-order-wrap">
				<table class="layui-table" v-if="requestParam.order_type === 1">
				  <thead>
				    <tr>
						<th>订单号</th>
						<th>买家昵称</th>
						<th>买家wxid</th>
						<!-- <th>客服昵称</th> -->
						<th>快递公司</th>
						<th>快递单号</th>
						<th>订单金额</th>
						<th>订单状态</th>
						<!-- <th>收货人电话</th> -->
						<th>创建时间</th>
				    </tr> 
				  </thead>
				  <tbody v-if="orderList.length > 0">
				    <tr v-for="order in orderList">
				      <td>{{order.order_number}}</td>
				      <td>{{order.buyer_nickname}}</td>
					  <td>{{order.buyer_wechatid}}</td>
					  <!-- <td>{{order.custom_nickname}}</td> -->
					  <td>{{order.express}}</td>
					  <td>{{order.express_no}}</td>
					  <td>{{order.total_money}}</td>
					  <td>{{order.order_status}}</td>
					 <!-- <td>{{order.receiver_mobile}}</td> -->
					  <td>{{order.create_time}}</td>
				    </tr>
				  </tbody>
				  <tbody v-else>
					  <tr>
						  <td colspan="8" style="text-align: center;">暂无订单数据</td>
					  </tr>
				  </tbody>
				</table>
				<table class="layui-table" v-else>
				  <thead>
				    <tr>
						<th>店铺名称</th>
						<th>商品名称</th>
						<th>金额</th>
						<th>数量</th>
						<th>订单号</th>
						<th>快单号</th>
						<th>快递公司</th>
						<th>收货人</th>
						<th>收货地址</th>
						<th>创建时间</th>
						<th>发货时间</th>
				    </tr> 
				  </thead>
				  <tbody v-if="orderList.length > 0">
				    <tr v-for="order in orderList">
					  <td>{{order.shop_name}}</td>
				      <td>{{order.product_name}}</td>
				      <td>{{order.total_amount}}</td>
					  <td>{{order.product_number}}</td>
					  <td>{{order.order_id}}</td>
					  <td>{{order.expressnum}}</td>
					  <td>{{order.expressname}}</td>
					  <td>{{order.post_receiver}}</td>
					  <td>{{order.post_addr}}</td>
					  <td>{{order.c_time}}</td>
					  <td>{{order.d_time}}</td>
				    </tr>
				  </tbody>
				  <tbody v-else>
					  <tr>
						  <td colspan="11" style="text-align: center;">暂无订单数据</td>
					  </tr>
				  </tbody>
				</table>
			</div>
		</div>
		<div class="chat-chat-order-page">
			<page-component
				:dataApi="dataApi" 
				:requestParams="requestParam"
				:autoInit = "autoInit"
				@page-call="pageCall($event)" 
				key="chat-chat-order-page"
				ref="ChatChatOrderPage">
			</page-component>
		</div>
	</div>
</template>

<script>
	import PageComponent from '../../components/PageComponent.vue'
	import {getOrderList} from '../../network/order/order.js'
	import {getLocalConfig,getLoginInfo} from '../../functions/Common.js'
	import {webGetCustomById} from '../../network/web/custom.js'
	import {webGetConfigByName} from '../../network/web/config.js'
	import {getThirdOrderList} from '../../network/web/other.js'
	
	export default{
		name:"ChatChatOrder",
		props:{
			chatUser:{
				type: Object,
				default: function(){
					return {}
				}
			}
		},
		components:{
			PageComponent
		},
		data(){
			return {
				orderList: [],
				dataApi: getOrderList,
				autoInit: false,
				requestParam:{
					start_time:'',
					end_time:'',
					prePage: 10,
					fansWxid: '',
					fansId: 0,
					company_id: '',
					order_type: 1
				},
			}
		},
		methods:{
			// 关闭页面
			closeOrder(){
				this.$emit('chat-order-close')
			},
			
			// 分页数据回调
			pageCall(data){
				this.orderList = data
			},
			
			// 搜索
			search(){
				this.$refs.ChatChatOrderPage.initPage()
			},
			
			// 搜索订单
			goOrder(){
				let manager_info = getLoginInfo();
				if(manager_info === false){
					CHAT_LAYER.msg('刷新页面后重试！')
					return
				}
				webGetCustomById(this.chatUser.custom_id,data=>{
					if(data.code == 0){
						CHAT_LAYER.msg('客服信息为空，无法下单！')
						return
					}
					let custom = data.data
					let url = getLocalConfig("orderUrl")
					if(url === ''){
						CHAT_LAYER.msg('下单地址为空！')
						return
					}
					url += 'admin/orders/save?manager_wechatid='+manager_info.name+'&buyer_wechatid='+ this.chatUser.fans_wx_id +'&buyer_nickname='+ this.chatUser.fans_wx_name +'&custom_wechatid='+ this.chatUser.custom_wx_id +'&custom_nickname='+this.chatUser.custom_wx_name
					window.open(url)
				})
			},
			
			// 订单切换
			changeOrder(){
				if(this.requestParam.order_type === 1){
					this.requestParam.order_type = 2
					this.dataApi = getThirdOrderList
				}else{
					this.requestParam.order_type = 1
					this.dataApi = getOrderList
				}
				this.$nextTick(()=>{
					this.search()
				})
				
			}
		},
		created() {
			this.requestParam.fansWxid = this.chatUser.fans_wx_id
			this.requestParam.fansId = this.chatUser.fans_id
			let _this = this
			webGetConfigByName('order_system_company_id',data=>{
				if(data.value !== undefined){
					let value = data.value
					if(value == 0){
						value = ''
					}
					_this.requestParam.company_id = value
					_this.search()
				}
			})
		}
	}
</script>

<style>
	.chat-chat-order{
		position: absolute;
		top: 158px;
		left: 20px;
		bottom: 158px;
		right: 20px;
		background-color: #FFFFFF;
		z-index: 11;
	}
	.chat-chat-order-title{
		height: 32px;
		line-height: 32px;
		background-color: #e8e8e8;
		padding: 0 10px;
		display: flex;
		justify-content: space-between;
	}
	.chat-chat-ot-close{
		cursor: pointer;
		padding: 0 10px;
	}
	.chat-chat-ot-name span{
		font-weight: bold;
	}
	.chat-chat-order-search{
		height: 28px;
		padding: 10px;
	}
	.chat-chat-order-search input{
		height: 26px;
		line-height: 26px;
		width: 170px;
		border: 1px solid #CCCCCC;
		padding: 0 5px;
		border-radius: 2px;
		color: #666666;
		margin-right: 3px;
	}
	.chat-chat-order-search button{
		padding: 0 10px;
		line-height: 28px;
		background-color: #009688;
		color: #FFFFFF;
		border-radius: 2px;
		cursor: pointer;
		margin-right: 3px;
	}
	.chat-chat-order-box{
		position: absolute;
		top: 80px;
		left: 0;
		right: 0;
		bottom: 60px;
		overflow: hidden;
	}
	.chat-chat-order-box .chat-chat-order-wrap{
		position: relative;
		height: 100%;
		padding: 0 10px;
		overflow-x: hidden;
		overflow-y: auto;
	}
	.chat-chat-order-wrap>table{
		margin: 0;
		/* table-layout: fixed; */
		word-break: break-all;
	}
	.chat-chat-order-page{
		position: absolute;
		left: 0;
		bottom: 0;
		width: 100%;
		height: 26px;
		padding: 17px 0;
	}
</style>
